import { render, staticRenderFns } from "./index-plotly.vue?vue&type=template&id=4f4c59e6&scoped=true"
import script from "./index-plotly.vue?vue&type=script&lang=js"
export * from "./index-plotly.vue?vue&type=script&lang=js"
import style0 from "./index-plotly.vue?vue&type=style&index=0&id=4f4c59e6&prod&lang=scss&scoped=true"
import style1 from "./index-plotly.vue?vue&type=style&index=1&id=4f4c59e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4c59e6",
  null
  
)

export default component.exports